// Auto-generated by sync-onboarding-content.mjs -- do not edit manually.
export const ONBOARDING_CONTENT_STACKS_BY_DIR: Record<string, readonly string[]> = {
  '1-connect-frontend-to-backend': [
    'angular',
    'astro',
    'nextjs',
    'preact',
    'qwik',
    'react',
    'solidjs',
    'svelte',
    'vanillajs',
    'vue',
    'webassembly',
  ],
  '2-expose-backend': ['dotnet', 'groovy', 'java', 'javascript', 'kotlin', 'python'],
  '3-connect-microservices': ['dotnet', 'java', 'javascript', 'python'],
  '4-use-modules-from-any-technology': ['dotnet', 'java', 'javascript', 'python'],
  '5-expose-mcp': ['dotnet', 'java', 'javascript', 'python'],
  '6-switch-between-monolith-and-microservices': ['dotnet', 'java', 'javascript', 'python'],
} as const
